import { render, staticRenderFns } from "./ConsentsCheckBoxes.vue?vue&type=template&id=9a31eecc"
import script from "./ConsentsCheckBoxes.vue?vue&type=script&lang=js"
export * from "./ConsentsCheckBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports